import { render, staticRenderFns } from "./edit_amo_licenses.vue?vue&type=template&id=f724fac4&scoped=true&"
import script from "./edit_amo_licenses.vue?vue&type=script&lang=js&"
export * from "./edit_amo_licenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f724fac4",
  null
  
)

export default component.exports